import { useEffect } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { useAuth } from "../contexts/AuthContext";
import { getLiveSocket, subscribeBinUpdates } from "../services/binSocket";
import { queryKeys } from "./keys";
import { binFromPayload } from "./bin";

// Socket stays for the push. React Query owns the copy every screen reads.
export default function RealtimeSync() {
  const { user } = useAuth();
  const queryClient = useQueryClient();

  useEffect(() => {
    if (!user) return undefined;
    return subscribeBinUpdates((bin) => {
      queryClient.setQueryData(queryKeys.bin, binFromPayload(bin));
      queryClient.invalidateQueries({ queryKey: queryKeys.sales });
      queryClient.invalidateQueries({ queryKey: queryKeys.notificationCount });
      queryClient.invalidateQueries({ queryKey: ["notifications"] });
    });
  }, [user, queryClient]);

  useEffect(() => {
    if (!user) return undefined;
    const socket = getLiveSocket();
    if (!socket) return undefined;
    const onNotification = () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.notificationCount });
      queryClient.invalidateQueries({ queryKey: ["notifications"] });
    };
    socket.on("notification:new", onNotification);
    return () => socket.off("notification:new", onNotification);
  }, [user, queryClient]);

  useEffect(() => {
    window.refreshNavbarCounts = () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.bin });
      queryClient.invalidateQueries({ queryKey: queryKeys.notificationCount });
      queryClient.invalidateQueries({ queryKey: ["notifications"] });
    };
    return () => {
      delete window.refreshNavbarCounts;
    };
  }, [queryClient]);

  return null;
}
